/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../../Config/Config';
import DropzoneComponent from 'react-dropzone-component';

export default class ImageFile extends Component {

    constructor(props) {
        super(props);
		// For a full list of possible configurations,
        // please consult http://www.dropzonejs.com/#configuration
        this.djsConfig = {
            addRemoveLinks: true,
			acceptedFiles: "image/jpeg,image/png,image/gif",
			maxFilesize: 20, // MB
        };

        this.componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.gif'],
            showFiletypeIcon: true,
            autoProcessQueue: true,
            postUrl: Constants.URL.root+'/webservices/uploadImage.php'
        };

        // If you want to attach multiple callbacks, simply
        // create an array filled with all your callbacks.
        this.callbackArray = [() => console.log('Hi!'), () => console.log('Ho!')];

        // Simple callbacks work too, of course
        this.callback = (file) => console.log('Hello!', file);

        this.success = (file, response) => {
        	//console.log(response, 'response');
        	//console.log(file, 'file');
        	//this.dispatchImageData(response);
            this.props.handler(this.props.id, response, file)
            this.props.lgClose();
			/* if (this.props.isUploadingFalse !== undefined)
				this.props.isUploadingFalse(); */
        }

        this.removedfile = file => console.log('removing...', file);
        this.dropzone = null;
    }

    render() {
        const config = this.componentConfig;
		const djsConfig = this.djsConfig;
		// For a list of all possible events (there are many), see README.md!
		const eventHandlers = {
			init: dz => this.dropzone = dz,
			drop: this.callbackArray,
			addedfile: this.callback,
			success: this.success,
			removedfile: this.removedfile
		}
	    return (
	    	<DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}>
				<div className="dz-message">
					Drop files here to upload
					<span>Max upload file size is 20MB</span>
				</div>
			</DropzoneComponent>
	    );
    }
}